import { EntrepreneurAnnounce8FormContainer } from "../../../containers/SupportSystem/SupportForm/EntrepreneurAnnounce8FormContainer";
export function EntrepreneurAnnounce8FormPage() {
    return (
        <EntrepreneurAnnounce8FormContainer/>
    );

}